console.log('MegaMenu: Script loaded');

class MegaMenu {
  constructor() {
    this.init();
  }

  init() {
    console.log('MegaMenu: Initializing...');
    this.menuItems = document.querySelectorAll('.mega-menu__item');
    this.imageSets = document.querySelectorAll('.mega-menu__images-set');
    
    console.log('MegaMenu: Found menu items:', this.menuItems.length);
    console.log('MegaMenu: Found image sets:', this.imageSets.length);
    
    if (!this.menuItems.length || !this.imageSets.length) {
      console.log('MegaMenu: Missing required elements, exiting');
      return;
    }

    this.bindEvents();
  }

  bindEvents() {
    console.log('MegaMenu: Binding events...');
    this.menuItems.forEach((item, index) => {
      const link = item.querySelector('.mega-menu__link');
      
      if (link) {
        const collectionIndex = link.getAttribute('data-collection-index');
        console.log(`MegaMenu: Menu item ${index + 1} has collection index:`, collectionIndex);
        
        if (collectionIndex !== null) {
          link.addEventListener('mouseenter', () => {
            console.log('MegaMenu: Hovering over collection index:', collectionIndex);
            this.showImageSet(collectionIndex);
          });
        }
      }
    });

    // Reset to first image set when leaving the mega menu
    const megaMenu = this.menuItems[0]?.closest('.mega-menu');
    if (megaMenu) {
      megaMenu.addEventListener('mouseleave', () => {
        console.log('MegaMenu: Leaving mega menu, resetting to first image set');
        this.showImageSet('0');
      });
    }
  }

  showImageSet(collectionIndex) {
    console.log('MegaMenu: Showing image set for collection index:', collectionIndex);
    
    // Hide all image sets
    this.imageSets.forEach(set => {
      set.classList.remove('active');
    });

    // Show the target image set
    const targetSet = document.querySelector(`.mega-menu__images-set[data-collection-index="${collectionIndex}"]`);
    if (targetSet) {
      targetSet.classList.add('active');
      console.log('MegaMenu: Activated image set for collection index:', collectionIndex);
    } else {
      console.log('MegaMenu: No image set found for collection index:', collectionIndex);
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new MegaMenu();
});

// Also initialize for dynamically loaded content
document.addEventListener('shopify:section:load', (event) => {
  const target = event.target;
  if (target && target.querySelector && target.querySelector('.mega-menu')) {
    new MegaMenu();
  }
}); 